import React, { useState } from "react";
import { Container, Row, Col, Button, Card, Image } from "react-bootstrap";

import eventImg from "../../assets/images/previewmembership/event.svg";
import communityImg from "../../assets/images/previewmembership/community.svg";
import networkImg from "../../assets/images/previewmembership/network.svg";
import celebrationImg from "../../assets/images/previewmembership/celebration.svg";
import mailImg from "../../assets/images/previewmembership/mail.svg";
import privilegeImg from "../../assets/images/previewmembership/privilages.svg";
import benifitesImg from "../../assets/images/previewmembership/benifites.svg";
import qrcodeImg from "../../assets/images/previewmembership/qrcode.svg";
import heritageImg from "../../assets/images/previewmembership/heritage.svg";
import networkingImg from "../../assets/images/previewmembership/networking.svg";
import participationImg from "../../assets/images/previewmembership/participation.svg";
import unitedImg from "../../assets/images/previewmembership/united.svg";
import checkIcon from "../../assets/images/previewmembership/checkicon.svg";

import membershipImg from "../../assets/images/previewmembership/membership_1.png";
import membershipImg2 from "../../assets/images/previewmembership/membership_2.png";
import { useNavigate } from "react-router-dom";
import LoginModal from "../../components/Login";

const BENEFITS = [
  {
    id: 1,
    title: "Access to All Community Events",
    text: "Complimentary entry to all cultural programs, festivals, and annual events throughout the year.",
    img: eventImg,
  },
  {
    id: 2,
    title: "Stay Connected with the Community",
    text: "Build meaningful relationships and stay connected with Gujarati families across Tampa Bay.",
    img: communityImg,
  },
  {
    id: 3,
    title: "Supportive Community Network",
    text: "Be part of a strong community that supports each other socially, personally, and professionally.",
    img: networkImg,
  },
  {
    id: 4,
    title: "Celebrate Festivals Together",
    text: "Join us in celebrating Holi, Navratri, Diwali, Uttarayan, and many other events as one united community.",
    img: celebrationImg,
  },
  {
    id: 5,
    title: "Member-Only Updates & Newsletters",
    text: "Receive exclusive updates, announcements, and community news directly via email.",
    img: mailImg,
  },
  {
    id: 6,
    title: "Special Member Privileges",
    text: "Enjoy exclusive benefits and priority access to special community programs and activities.",
    img: privilegeImg,
  },
  {
    id: 7,
    title: "Family Membership Benefits",
    text: "Register your family members under one membership and let them enjoy all community activities.",
    img: benifitesImg,
  },
  {
    id: 8,
    title: "Digital Tickets & QR Code Convenience",
    text: "Get automatic digital tickets and QR codes for smooth and quick event entry.",
    img: qrcodeImg,
  },
  {
    id: 9,
    title: "Preserve Gujarati Culture & Heritage",
    text: "Help keep our traditions and cultural values alive for the next generation.",
    img: heritageImg,
  },
  {
    id: 10,
    title: "Networking & Growth Opportunities",
    text: "Connect with professionals, entrepreneurs, and community leaders within our Samaj.",
    img: networkingImg,
  },
  {
    id: 11,
    title: "Community Service & Welfare Participation",
    text: "Engage in various volunteer and social service activities organized throughout the year.",
    img: participationImg,
  },
  {
    id: 12,
    title: "A Strong & United Community",
    text: "Your membership strengthens unity, collaboration, and the growth of Gujarati Samaj of Tampa Bay Inc.",
    img: unitedImg,
  },
];

// Renewals use plain strings
const bullets = [
  "Login using your registered mobile number or email address along with the password you used when you first signed up.",
  "After successful login, you can review and update your profile, including your family members' details.",
  "Proceed to the payment page and pay online using your credit card.",
];

// New members use objects with JSX in `content` (option 3)
const bullets1 = [
  {
    id: 1,
    content: (
      <>
        Please click <a href="/membership">Sign Up</a> to create a new account.
      </>
    ),
  },
  {
    id: 2,
    content: (
      <>Fill out the registration form with accurate personal details.</>
    ),
  },
  {
    id: 3,
    content: (
      <>
        After submitting the form, you will be directed to a screen where you
        can add your family members before proceeding to payment.
      </>
    ),
  },
  {
    id: 4,
    content: (
      <>Upload a recent photograph and ensure all information is correct.</>
    ),
  },
  {
    id: 5,
    content: (
      <>
        After registration, you can log in anytime using your registered mobile
        number or email address and password to access your dashboard and manage
        your profile.
      </>
    ),
  },
];

function BenefitCard({ item }) {
  const { title, text, img } = item;

  return (
    <Card className="benefit-card h-100 border-0 p-4 mb-2">
      <Card.Body className="d-flex gap-4 align-items-start flex-column p-0">
        <div className="icon-wrap">
          <img src={img} alt={title} className="benefit-icon" />
        </div>
        <div>
          <Card.Title className="mb-1 fw-semibold mb-2">{title}</Card.Title>
          <Card.Text className="fw-normal mb-0">{text}</Card.Text>
        </div>
      </Card.Body>
    </Card>
  );
}

function BenefitsSection() {
  const navigate = useNavigate();
  const [isLoginOpen, setIsLoginOpen] = useState(false);
  return (
    <section className="benefits-section py-5">
      <Container>
        <Row className="d-flex justify-content-center">
          <Col lg={9}>
            <div className="hero text-center mb-4">
              <h1 className="mb-2 h1">Become a Member Today!</h1>
              <p className="mb-3">
                Proudly serving the Tampa Bay area since 1981 Gujarati Samaj of
                Tampa Bay Inc is a Florida Non-Profit Corporation
              </p>
              <p>
                Becoming a member of Gujarati Samaj of Tampa Bay Inc means
                joining a vibrant, culturally rich, and united community
                dedicated to preserving our heritage while supporting and
                uplifting every member.
              </p>
              <div className="d-flex justify-content-center gap-3 my-4">
                <Button
                  className="btn btn-orange px-4"
                  onClick={() => navigate("/register")}
                >
                  Join Now
                </Button>
                <Button
                  variant="dark"
                  className="px-4"
                  onClick={() => setIsLoginOpen(true)}
                >
                  Member Login
                </Button>
              </div>
            </div>
          </Col>
        </Row>

        <hr />
        <div className="benifit-heading text-center my-4">
          <h2 className="mb-3 fw-bold ">Benefits of Becoming a Member</h2>
        </div>
        <Row className="g-3">
          {BENEFITS.map((b) => (
            <Col key={b.id} xs={12} md={6} lg={4}>
              <BenefitCard item={b} />
            </Col>
          ))}
        </Row>
      </Container>
      {isLoginOpen && (
        <LoginModal
          isOpen={isLoginOpen}
          onClose={() => setIsLoginOpen(false)}
        />
      )}
    </section>
  );
}

function RenewalsSection() {
  const [isLoginOpen, setIsLoginOpen] = useState(false);
  return (
    <section className="renewals-section py-5">
      <Container>
        <Row className="align-items-center mx-auto">
          {/* Left column: text/content */}
          <Col md={12} lg={6}>
            <h4 className="mb-2">Membership Renewals</h4>

            <p className="fw-semibold text-muted mb-3">
              If you were a member of GSTB in a previous year, the renewal
              process is simple:
            </p>

            {/* Renewal steps rendered as div rows (use bullets array of strings) */}
            <div className="renew-list mb-4">
              {bullets.map((text, idx) => (
                <div
                  key={idx}
                  className="renew-item d-flex align-items-start mb-3"
                >
                  <span
                    className="check-box d-inline-flex align-items-center justify-content-center me-3 mt-1"
                    aria-hidden
                  >
                    <img
                      src={checkIcon}
                      alt="check icon"
                      className="check-img"
                    />
                  </span>

                  <span className="renew-text">{text}</span>
                </div>
              ))}
            </div>

            {/* Important notes */}
            <h6 className="fw-bold mb-2">Important Notes:</h6>

            <p className="mb-2 text-muted">
              We strongly encourage renewing your membership online so that you
              continue receiving newsletters and community emails regularly.
            </p>

            <p className="mb-4 text-muted">
              Members who renew their membership before March each year receive
              a $10 discount when paying by credit card.
            </p>

            <Button
              className="btn btn-orange-md"
              onClick={() => setIsLoginOpen(true)}
            >
              Login to Renew
            </Button>
          </Col>

          {/* Right column: image */}
          <Col md={12} lg={6} className="text-center">
            <div className="renewal-image-wrapper ms-lg-5 ms-0 d-flex justify-content-end align-items-center">
              <Image
                src={membershipImg}
                alt="Membership renewal"
                rounded
                fluid
                className="renewal-image"
              />
            </div>
          </Col>
        </Row>
      </Container>
      {isLoginOpen && (
        <LoginModal
          isOpen={isLoginOpen}
          onClose={() => setIsLoginOpen(false)}
        />
      )}
    </section>
  );
}

function NewMembersSection() {
  const navigate = useNavigate();
  return (
    <section className="newmembers-section py-5 bg-white">
      <Container>
        <Row className="align-items-center mx-auto section-direction">
          {/* Left image */}
          <Col md={12} lg={5} className="mb-4 mb-md-0">
            <div className="member-image-wrapper">
              <Image
                src={membershipImg2}
                alt="New members"
                rounded
                fluid
                className="member-image"
              />
            </div>
          </Col>

          {/* Right content */}
          <Col md={12} lg={6} className="ms-lg-5">
            <h4 className="mb-2">New Members</h4>
            <p className="fw-semibold text-muted mb-3">
              If you are joining GSTB for the first time
            </p>

            <div className="newmember-list list-unstyled mb-4">
              {bullets1.map((b) => (
                <div key={b.id} className="d-flex align-items-start mb-3">
                  <span className="check-box d-inline-flex align-items-center justify-content-center me-3 mt-1">
                    <img
                      src={checkIcon}
                      alt="check icon"
                      className="check-img"
                    />
                  </span>
                  <div className="renew-text">{b.content}</div>
                </div>
              ))}
            </div>

            <Button
              className="btn btn-orange-md"
              onClick={() => navigate("/register")}
            >
              Register Now
            </Button>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

function CTASection() {
  const navigate = useNavigate();
  return (
    <section>
      <Container>
        <Row className="align-items-center cta-section py-4 mx-auto">
          <Col sm={12} md={9} lg={9} className="p-lg-5 p-md-4 px-4">
            <h5 className="mb-3 cta-title fw-bold">
              Ready to Join Our Community?
            </h5>
            <p className="mb-0 cta-text fw-regular">
              Register your membership today!
            </p>
          </Col>
          <Col
            sm={12}
            md={3}
            lg={3}
            className="text-md-end mt-md-3 mt-4 mt-md-0 p-lg-5 p-md-4 px-4"
          >
            <Button
              className="btn btn-orange-md"
              onClick={() => navigate("/register")}
            >
              Join Us
            </Button>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default function PreviewMember() {
  return (
    <div>
      <style>{`
        .benefits-section { background: #ffffff; }
        .hero h1 { font-size: 28px; font-weight: 700; }
        .hero .lead { max-width: 720px; margin: 0 auto; }

        .btn-cta { background: #f2b33d; color: #fff; border: none; border-radius: 8px; }

        .benefit-card { border-radius: 16px; padding: 10px; background: var(--card-bg);}
        .benefit-card .card-title { font-size: 18px; margin-bottom: 6px; font-weight: 600; color:var(--text-main) }
        .benefit-card .card-text { font-size: 14px; color:var(--text-2); line-height:24px; }

        .icon-wrap { width: 56px; height: 56px; border-radius: 10px; background: var(--white); display:flex; align-items:center; justify-content:center; color:#c27b16; box-shadow: 0 2px 6px rgba(0,0,0,0.03); }

        .renewals-section { background: #fff; }
        .renewals-section h4, .newmembers-section h4 { font-weight: 700; }

        .cta-section { background: #EDA92B1A; border-radius: 16px; }
        .cta-title { font-size: 26px; color: var(--text-main) }
        .cta-text{ font-size: 16px; color: var(--text-2); line-height: 16px; }
        .text-muted { color: var(--text-2) !important; }
        .renew-text{ color: var(--text-2); font-size: 15px; line-height: 24px; }
        .icon-check , .renew-text a{ color: #EDA92B; }


        @media (max-width: 767px) {
          .hero h1 { font-size: 22px; }
          .icon-wrap { width: 44px; height: 44px; }
        }
      `}</style>

      <div style={{ height: 16 }} />
      <BenefitsSection />
      <RenewalsSection />
      <NewMembersSection />
      <CTASection />
      <div style={{ height: 48 }} />
    </div>
  );
}
